












import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'

@Component({
  components: { TesTd, DateTooltipped }
})
export default class DateTooltippedTableCell extends Vue {
  @Prop() value!: string
  @Prop() row!: any
  @Prop() props!: any
  @Prop() grid!: boolean
}
